import React from 'react';
import deleteIcon from '../../../assets/images/delete-icon.svg';
import ConfirmModal from '../../../components/ConfirmModal';

interface DeleteFeaturedBannerModalProps {
  isOpen: boolean;
  featuredBannerId: number | null;
  handleClose: () => void;
  handleSubmit: (featuredBannerId: number) => Promise<void>;
}
const DeleteFeaturedBannerModal: React.FC<DeleteFeaturedBannerModalProps> = (props) => {
  const {
    isOpen, featuredBannerId, handleClose, handleSubmit,
  } = props;
  return (
    <ConfirmModal
      isOpen={isOpen}
      handleClose={handleClose}
      handleSubmit={() => featuredBannerId !== null && handleSubmit(featuredBannerId)}
      subTitle="Are you sure you want to clear this image?"
      imageUrl={deleteIcon}
    />
  );
};

export default DeleteFeaturedBannerModal;
